var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"adm-btn-ctl",style:({ background: _vm.color }),on:{"click":function($event){return _vm.$emit('on-watch', { id: _vm.id, watch: _vm.isWatch })}}},[_vm._v(_vm._s(_vm.title)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }